<script setup lang="ts">
import { armarUrl } from '@idem/common/armar-url';
import { textosSecciones as textos } from '@frontend/secciones/textos';

defineProps<{ actividad: { nombre: string; foto: string | null } }>();
</script>

<template>
  <img v-if="actividad.foto" :src="armarUrl(actividad.foto)" :alt="actividad.nombre" class="aspect-video w-full object-cover" />
  <div v-else class="flex aspect-video w-full items-center justify-center bg-gray-100 text-sm text-gray-400">
    {{ textos.sinFoto }}
  </div>
</template>
